
import { defineComponent, ref, h } from 'vue'
import {
  useMessage,
  NButton,
  NModal,
  NIcon,
  NCollapse,
  NCollapseItem,
  NSpin,
  DataTableColumns,
  NDataTable,
  CollapseProps,
} from 'naive-ui'
import { API } from '@/api/api'
import { AlbumsOutline } from '@vicons/ionicons5'
import ModalHistoricDetailVue from './ModalHistoricDetail.vue'

const createColumns = (): DataTableColumns<any> => {
  return [
    {
      title: 'Ação',
      key: 'descricao',
    },
    {
      title: 'Usuario',
      key: 'usuario.nome',
    },
    {
      title: 'Data',
      key: 'date',
      render: (row) => {
        return new Date(row.created_at).toLocaleString()
      },
    },
    {
      title: '',
      key: 'actions',
      render(row) {
        return h(ModalHistoricDetailVue, {
          file: row,
        })
      },
    },
  ]
}

const createColumnsDocuments = (site: any): DataTableColumns<any> => {
  return [
    {
      title: 'Extenção',
      key: 'extensao',
    },
    {
      title: 'Data de upload',
      key: 'created_at',
      render: (row) => {
        return new Date(row.created_at).toLocaleString()
      },
    },
    {
      title: '',
      key: 'actions',
      render(row) {
        return h(
          NButton,
          {
            strong: true,
            type: 'success',
            size: 'small',
            onClick: () => {
              window.open(`https://${site.url}${row.url}`, '_blank')
            },
          },
          { default: () => 'Visualizar' }
        )
      },
    },
  ]
}

export default defineComponent({
  components: {
    NButton,
    NModal,
    NIcon,
    AlbumsOutline,
    NCollapse,
    NCollapseItem,
    NSpin,
    NDataTable,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
    site: {
      type: Object as any,
      required: true,
    },
  },
  setup(props) {
    const showModal = ref(false)
    const historics = ref<any>()
    const documents = ref<any>()
    const isLoading = ref(false)

    async function fetchHistoric() {
      try {
        isLoading.value = true
        const response = await API().get(
          `/dashboard/arquivos/${props.file.id}/historico`
        )
        if (response.status == 200) {
          historics.value = response.data
        } else {
          useMessage().error('Erro ao carregar histórico')
        }
      } catch (error) {
        console.error(error)
        useMessage().error(
          'Erro interno - Tente novamente mais tarde e contate o suporte.'
        )
      } finally {
        isLoading.value = false
      }
    }

    async function fetchDocuments() {
      try {
        isLoading.value = true
        const response = await API().get(
          `/dashboard/arquivos/${props.file.id}/documentos`
        )
        if (response.status == 200) {
          documents.value = response.data
        } else {
          useMessage().error('Erro ao carregar documentos')
        }
      } catch (error) {
        console.error(error)
        useMessage().error(
          'Erro interno - Tente novamente mais tarde e contate o suporte.'
        )
      } finally {
        isLoading.value = false
      }
    }

    const collapseSelect: CollapseProps['onItemHeaderClick'] = ({
      name,
      expanded,
    }) => {
      if (name == 1 && expanded == true) {
        fetchDocuments()
      } else if (name == 2 && expanded == true) {
        fetchHistoric()
      }
    }

    return {
      showModal,
      collapseSelect,
      isLoading,
      historics,
      columns: createColumns(),
      pagination: false as const,
      columnsDocuments: createColumnsDocuments(props.site),
      documents,
    }
  },
})
